import createCrudModule from 'vuex-crud';
import {client, parseResponse} from '@/api'

export default createCrudModule({
  resource: 'privateLibrairies',
  idAttribute: 'id',
  client,
  parseSingle: parseResponse,
  parseList: parseResponse,
  customUrlFn(slug) {
    return slug ? process.env.VUE_APP_API+`api/private-librairies/view/${slug}` :  process.env.VUE_APP_API+'api/private-librairies';
  }
});
